export { default as Modal } from './Modal';



// WEBPACK FOOTER //
// ./src/components/modal/index.tsx